import React, { useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logo1 from "../Assets/Images/Hum Hai Logo 550 300.png";
import logo2 from "../Assets/Images/Sartrac Logo 550 300.png";
import showname from "../Assets/Images/Wazir Logo.png"
import "./reststyle.css";

export const TicketGenerateRest = () => {
    const [numItems, setNumItems] = useState();
    const [items, setItems] = useState([]);
    const [price, setPrice] = useState("");
    const [category, setCategory] = useState("");
    const [Seatno, setSeatno] = useState("");
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [venue, setVenue] = useState("");
    const [showName, setShowName] = useState("");
    const [showNameLogo, setShowNameLogo] = useState(null);
// const [pdfPreview, setPdfPreview] = useState(null);
    const pdfContainerRef = useRef(null);

 const generatePDFs = async () => {
    const container = pdfContainerRef.current;
    const pdfs = [];

    for (let i = 0; i < numItems; i++) {
      const element = container.querySelector(`#pdf-component-${i + 1}`);
      const canvas = await html2canvas(element, { scale: 2 });
      const imageData = canvas.toDataURL('image/jpeg');
      pdfs.push(imageData);
    }

    const mergedPDF = new jsPDF('landscape', 'mm', 'a4');
    pdfs.forEach((imageData, index) => {
      if (index > 0) {
        mergedPDF.addPage();
      }
      mergedPDF.addImage(imageData, 'JPEG', 0, 0, 297, 210);
    });

    mergedPDF.save(`${category}-${Seatno}-${numItems}`);
  };


    const handleInputChange = (e) => setNumItems(parseInt(e.target.value, 10));

    const handleGeneratePDFs = () => {
        const newItems = [];
        for (let i = 1; i <= numItems; i++) {
            newItems.push({
                id: i,
                price,
                category,
                Seatno: `${Seatno}-${i}`,
                date,
                time,
                venue,
                showName,
            });
        }
        setItems(newItems);
    };

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) setShowNameLogo(URL.createObjectURL(file));
    };

    return (
        <div>
            {/* Input Section */}
            <div className="input-section">
                <input type="text" value={showName} onChange={(e) => setShowName(e.target.value)} placeholder="Show Name" />
                <input type="number" value={numItems} onChange={handleInputChange} placeholder="Number of Tickets" />
                <input type="text" value={price} onChange={(e) => setPrice(e.target.value)} placeholder="Price" />
                <input type="text" value={category} onChange={(e) => setCategory(e.target.value)} placeholder="Category" />
                <input type="text" value={Seatno} onChange={(e) => setSeatno(e.target.value)} placeholder="Seat Number Prefix" />
                <input type="text" value={date} onChange={(e) => setDate(e.target.value)} placeholder="Date" />
                <input type="text" value={time} onChange={(e) => setTime(e.target.value)} placeholder="Time" />
                <input type="text" value={venue} onChange={(e) => setVenue(e.target.value)} placeholder="Venue" />
                <input type="file" accept="image/*" onChange={handleLogoUpload} />
                <button onClick={handleGeneratePDFs}>Generate Tickets</button>
           
            </div>

            {/* Ticket Preview */}
            <div ref={pdfContainerRef} className="pdf-container">
                {items.map((item) => (
                    <div key={item.id} className="ticket-alt" id={`pdf-component-${item.id}`}>
                        {/* Top Section */}
                        <div className="ticket-top">
                            
                                <img className="ticket-logo" src={showname} alt="Show Logo" />
                         
                        </div>

                        {/* Middle Section */}
                        <div className="ticket-middle">
                            <div className="ticket-left">
                                <p className="ticket-price">₹ {item.price}</p>
                                <p className="ticket-category">{item.category}</p>
                            </div>
                            <div className="ticket-right">
                                <p className="ticket-seat">Seat: {item.Seatno}</p>
                            </div>
                        </div>

                        {/* Divider */}
                        <div className="ticket-divider">
                            <span>✂─────────────────────────✂</span>
                        </div>

                        {/* Bottom Section */}
                        <div className="ticket-bottom">
                            <p>📍 {item.venue}</p>
                            <p>📅 {item.date} | ⏰ {item.time}</p>
                            <div className="bottom-logos">
                                <img className="logo" src={logo1} alt="Logo 1" />
                                <img className="logo" src={logo2} alt="Logo 2" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <button onClick={generatePDFs}>Download All Tickets</button>
        </div>
    );
};
